import { getClickId } from '@/utils/click-id';

/**
 * The partner click id, kept here for the ~20 call sites that already import it from this module.
 *
 * It no longer asks the SDK. `Affiliate.getCookie()` only answers after `Affiliate.init()` has run in
 * the `onReady` of `src/templates/main.tsx:22`, so anything reading it on mount raced the script and
 * saw nothing on a direct landing from a partner link; and it parsed the cookie with no try, so a
 * malformed one threw into the caller. `src/utils/click-id.ts` reads cookie-then-URL synchronously and
 * never throws — this module imports it, never the other way around, or the two files form a cycle.
 *
 * Answers '' and not undefined: 14 gateway call sites test the result with `clickId.length > 0` and
 * put it straight into a checkout body.
 */
export function getCookie(): string {
  return getClickId() ?? '';
}

/**
 * Save custom event
 *
 * @param action - The name of the custom event to be saved
 *
 * Unchanged in effect by the read above: with the SDK still loading, `getCookie()` can now answer a
 * click id where it used to answer '', so instead of returning early the call reaches
 * `Affiliate.customAction`, which is either undefined (`ReferenceError`) or throws
 * `'Affiliate SDK not initialized'`. Both land in the catch below — nothing is sent either way.
 */
export async function customEvent(action: string) {
  const cookie = getCookie();

  if (!cookie) return;

  try {
    // @ts-ignore
    await Affiliate.customAction(cookie, action);
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
}

/**
 * Identify the frequency of the plan and save it as a custom action
 *
 * @param frequency - The frequency in days to determine the type of plan (e.g., 30 for monthly, 365 for yearly)
 */

export async function identifySalesPlan(frequency: number) {
  let frequencyPlan = '';
  switch (frequency) {
    case 30:
      frequencyPlan = 'venda_mensal';
      break;
    case 365:
      frequencyPlan = 'venda_anual';
      break;
    default:
      frequencyPlan = 'venda_semanal';
      break;
  }

  await customEvent(frequencyPlan);
}
